export const DescriptionText = ({ html }: { html: string }) => {
  return (
    <div
      className='text-md text-gray-500 [&_p]:mb-3'
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};
